import * as Yup from 'yup'

import lang from '@/lang'

export const NAME_LENGTH = 30
export const SUMMARY_LENGTH = 125

const callbackUrl = Yup.string()
  .trim()
  .url(lang.invalidUrl)
  .test('is-https', lang.invalidUrl, value => {
    return value ? value.startsWith('https://') : true
  })
  .required(lang.emptyRequiredFieldsErrorMessage)

const name = Yup.string().max(NAME_LENGTH, lang.maxLength).required(lang.emptyRequiredFieldsErrorMessage)

export const keyValidationSchema = Yup.object({
  name,
  callbackUrl,
})

export const editValidationSchema = Yup.object({
  callbackUrl,
  name,
  summary: Yup.string().max(SUMMARY_LENGTH, lang.maxLength),
})
